import { useQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { queryOptions } from "../../../../../search/hooks";
import { Analysis, AnalysisCounts } from "../../../../@types/";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const useGetAnalysisCount = (
  hash: string | undefined,
  analysis: Analysis,
  uploadId?: string
) => {
  const endpoint = uploadId
    ? route(`api_${analysis}_url_analysis_counts`, [uploadId])
    : route(`api_${analysis}_analysis_counts`, [hash]);
  const { data } = useQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.analysisCount(endpoint),
    queryFn: () => api.getDynamicAnalysisData<AnalysisCounts>(endpoint),
    select: ({ data: counts }) => counts
  });

  return { data };
};

export default useGetAnalysisCount;
